(function ($) {
  Drupal.behaviors.videoLandingFormatterV1 = {
    attach: function (context) {
      var $template = $('.js-video-landing-formatter--v1', context);
      var $grid = $('.js-video-landing-grid', $template);
      var $gridItem = $('.js-video-landing-tile--v1', $template);
      var $filterSelect = $('.js-video-landing-filter__dropdown', $template);
      var $loadMore = $('.video-landing-load-more', $template);
      var $loadMoreBtn = $('.video-landing-load-more__btn', $template);
      var $failContainer = $('.video-landing-fail', $template);
      var $filterHeader = $('.js-video-landing-header__copy', $template);
      var filterHeaderCopy = $filterHeader.text();
      var loadMoreCount = $loadMoreBtn.attr('data-show');

      $filterSelect.on('change', function () {
        var value = this.value;
        var text = $('option:selected', this).attr('data-subheader');
        var newValue;

        if (value === 'all') {
          newValue = value;
        } else {
          newValue = '.video-landing-tile--' + value;
        }
        $grid.mixItUp('filter', newValue);
        // Updates subheader copy else use default copy
        if (text) {
          $filterHeader.text(text);
        } else {
          $filterHeader.text(filterHeaderCopy);
        }
      });

      $grid.mixItUp({
        selectors: {
          target: '.js-video-landing-tile--v1'
        },
        controls: {
          enable: false
        },
        animation: {
          // enable: false,
          duration: 400,
          effects: 'fade translateZ(-360px) stagger(34ms)',
          easing: 'ease'
        },
        callbacks: {
          onMixLoad: function (state) {
            $gridItem.slice(loadMoreCount, state.totalTargets).hide();
          },
          onMixStart: function (state, futureState) {
            $failContainer.hide();
            $loadMore.hide();
          },
          onMixFail: function (state) {
            $failContainer.show();
          }
        }
      });

      if ($gridItem.length > loadMoreCount) {
        $loadMore.show();
      } else {
        $loadMore.hide();
      }
      // Load 'n' more items
      $loadMoreBtn.on('click', function () {
        var $hiddenVideo = $('.js-video_landing_tile_image:hidden').first();

        if ($gridItem.is(':hidden')) {
          $('.js-video-landing-tile--v1:hidden').slice(0, loadMoreCount).fadeIn(400);
        } else {
          // Hide button if all items are already shown
          $loadMore.hide();
        }
        $hiddenVideo.focus();
      });
    }
  };
})(jQuery);
